import { TRestrictionsRequest } from "src/@types/restrictions";
import GenericDAO from "../GenericDAO";

const route = "/v1/clients/:id/client-status";

const getStatus = async (data: TRestrictionsRequest) => GenericDAO.replaceGetById(route, data.clientId, true);

export default {
    getStatus
};